<template>
  <div class="py-2">
    <label :for="label" class="block text-xss font-medium text-gray-700">
      {{ label }}
    </label>
    <div v-if="description" class="text-gray-500 text-xs">
      {{ description }}
    </div>
    <Combobox v-model="selected">
      <div class="relative">
        <div class="relative">
          <!-- Adiciona o botão X se houver uma seleção -->
          <ComboboxInput @focus="openDropdown"
            class="bg-white relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-slate-500 focus:border-slate-500 sm:text-xss"
            :displayValue="(item) => item?.name" @change="searchTo" />

          <!-- Botão para remover a seleção -->
          <ComboboxButton v-if="selected" @click="unSelected()" class="absolute inset-y-0 right-8 flex items-center pr-2">
            <XMarkIcon class="h-4 w-4 text-gray-500 hover:text-red-500 cursor-pointer" />
          </ComboboxButton>

          <!-- Botão de navegação (seta para baixo) -->
          <ComboboxButton class="absolute inset-y-0 right-0 flex items-center pr-2">
            <ArrowsUpDownIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
          </ComboboxButton>
        </div>

        <TransitionRoot leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0"
          @after-leave="query = ''">
          <ComboboxOptions
            class="z-10 absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-xss shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-xss">
            <div v-if="filteredDataRows.length === 0 && query !== ''"
              class="relative cursor-default select-none py-2 px-4 text-gray-700">
              Not found
            </div>
            <ComboboxOption v-for="item in filteredDataRows" as="template" :key="item.id" :value="item"
              v-slot="{ selected, active }">
              <li @click="update(item)" class="relative cursor-default select-none py-2 pl-10 pr-4"
                :class="{ 'bg-slate-600 text-white': active, 'text-gray-900': !active }">

                <span class="truncate flex" :class="{ 'font-medium': selected, 'font-normal': !selected }">
                  <div class="pr-2" v-if="hasUserLimit(item)">
                    <div v-html="checkStatus(item?.many_core_system_config_usersLimit[0])"></div>
                  </div>
                  <div class="pr-2 shrink-0">
                    <img :src="item.avatar || '/imgs/avatar.jpg'" class="inline-block h-5 w-5 rounded-full" />
                  </div>
                  {{ item.name }} - {{ item.email }}
                </span>
                <span v-if="selected" class="absolute inset-y-0 left-0 flex items-center pl-3"
                  :class="{ 'text-white': active, 'text-teal-600': !active }">
                  <CheckIcon class="h-5 w-5" aria-hidden="true" />
                </span>
              </li>
            </ComboboxOption>
          </ComboboxOptions>
        </TransitionRoot>

        <div v-if="error" class="text-red-500 text-xs mt-1">
          {{ error }}
        </div>
      </div>
    </Combobox>
  </div>
</template>


<script>

import {
  Combobox,
  ComboboxInput,
  ComboboxButton,
  ComboboxOptions,
  ComboboxOption,
  TransitionRoot,
} from '@headlessui/vue'

import { CheckIcon, ArrowsUpDownIcon, XMarkIcon } from '@heroicons/vue/24/solid'

export default {

  name: 'DropDownSearchMembers',
  props: {
    label: String,
    description: String,
    settings_workspaces_id: String,
    settings_departaments_id: [String, Array],
    show_user: {
      type: Boolean,
      default: true,
    },
    value: [String, Object, Boolean],
    allMembers: Boolean,
    
    dataRows: Array,

    // Responsável por mostrar apenas usuários online
    userOnline: {
      type: Boolean,
      default: false,
    },
    error: String,
  },
  data() {
    return {
      urlMembers: this.allMembers ? 'core/components/fields/allMembers' : 'core/components/fields/members',
      
      query: '',
      item: {},
      selected: '',
      params: {
        settings_workspaces_id: '',
        settings_departaments_id: '',
      },
    }
  },
  components: {
    Combobox,
    ComboboxInput,
    ComboboxButton,
    ComboboxOptions,
    ComboboxOption,
    TransitionRoot,
    CheckIcon,
    ArrowsUpDownIcon,
    XMarkIcon,

  },
  methods: {

    openDropdown() {

      // Forçar o foco e a abertura do Combobox
      this.$nextTick(() => {
        const comboboxInput = this.$el.querySelector('input');
        if (comboboxInput) {
          // Simular uma tecla de seta para baixo para abrir o dropdown
          comboboxInput.dispatchEvent(new KeyboardEvent('keydown', { key: 'ArrowDown' }));
        }
      });
    },


    checkStatus(objStatus) {
      if (objStatus.connection_state == 'online' && objStatus.user_state == 'online') {
        return '<span class="text-green-500">●</span>'
      }
      else {
        return '<span class="text-red-500">●</span>'
      }
    },

    hasUserLimit(item) {
      // Verifica se o item e a propriedade existem e se o array tem pelo menos um elemento
      return item && item.many_core_system_config_usersLimit && item.many_core_system_config_usersLimit.length > 0;
    },

    getMembers() {

      this.$ApiService.post(this.urlMembers, this.params).then(response => {
        // Caso não seja para mostrar o usuárial atual (logado)
        if (!this.show_user) {

          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].id == this.$SessionService.getUser().id) {
              response.data.splice(i, 1)
            }
          }
        }

        let users = response.data

        // apenas usuários online
        if (this.userOnline) {
          users = response.data.filter((user) => user.many_core_system_config_usersLimit[0].connection_state == 'online' && user.many_core_system_config_usersLimit[0].user_state == 'online')
        }

        this.dataRows = users;

        if (this.value) {
          this.selected = this.dataRows.find((dr) => dr.id === this.value);
        }
      });
    },

    searchTo($event) {
      this.query = $event.target.value
    },
    unSelected() {
      this.selected = '';
      this.$emit('update:modelValue', null);
    },

    update(item) {
      this.item = item;
      this.$emit('update:modelValue', this.item.id);
    },

    nivel(nivel) {
      let seta = '|';
      if (nivel && nivel > 0) {
        for (let i = 0; i <= nivel; i++) {
          seta = seta + 'ㅤ';
        }
        seta = seta + '›';
      }
      else {
        seta = '•';
      }
      return seta
    },

    search(item) {
      return (item.name||"").toLowerCase().indexOf((this.query||"").toLowerCase()) > -1 || (item.email||"").toLowerCase().indexOf((this.query||"").toLowerCase()) > -1
    },
  },

  computed: {
    filteredDataRows() {
      // Impede que sejam mostrados dados (apenas não retorna nada)
      if (this.dataRows === undefined || !this.dataRows.length) {
        return '';
      }
      return this.dataRows.filter(item => {
        if (this.search(item)) { return item.name }
      });
    },
  },

  watch: {
    settings_departaments_id(newValue) {
      this.params.settings_departaments_id = newValue;
      this.selected = '';
      this.$emit('update:modelValue', null);
      this.getMembers();
    },

    settings_workspaces_id(newValue) {
      this.params.settings_workspaces_id = newValue;
      this.selected = '';
      this.$emit('update:modelValue', null);
      this.getMembers();
    },
  },

  created() {
    this.params.settings_departaments_id = this.settings_departaments_id;
    this.params.settings_workspaces_id = this.settings_workspaces_id;

    setTimeout(() => {
      this.getMembers();
    }, 100);


  },
}

</script>
